
import {map} from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { Observable } from 'rxjs';
import * as urlParse from 'url-parse';
import { CookieAdapterService } from '../core/cookie-adapter.service';
import { CustomQueryEncoderHelper } from '../shared/helpers/custom-query-encode-helper';
import { LoginDto, LoginErrorReason } from '../shared/types/LoginDto';
import { ResetPasswordDto } from '../shared/types/ResetPasswordDto';
import { Login } from './login';

@Injectable()
export class LoginService {
  constructor(private http: HttpClient, private cookieService: CookieAdapterService) { }

  loginWithModel(model: Login): Observable<LoginDto> {
    const SAVED_USERNAME_COOKIE_KEY = 'savedUsername';
    this.cookieService.put(SAVED_USERNAME_COOKIE_KEY, model.email);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    const body = new URLSearchParams('', new CustomQueryEncoderHelper());
    body.set('j_username', model.email);
    body.set('j_password', model.password);
    body.set('source', '');
    if (model.rememberMe) {
      body.set('rememberLogin', 'on');
    }

    return this.http
      .post('/j_spring_security_check', body.toString(), {
        responseType: 'text',
        observe: 'response',
        headers: headers,
      }).pipe(
      map(res => {
        const { url, status } = res;
        const { query } = urlParse(url, true);
        const countryCode = query['countryCode'];
        const hasLoginError = query['login_error'] != null;

        if (status === 200) {
          if (hasLoginError) {
            const loginAttempt = parseInt(query['login_error'], 10);
            const doesEmailExist = this.cookieService.get(SAVED_USERNAME_COOKIE_KEY) != null;
            if (!doesEmailExist) {
              return { success: false, reason: LoginErrorReason.EMAIL_ERROR, attempt: loginAttempt };
            }
            return { success: false, reason: LoginErrorReason.PASSWORD_ERROR, attempt: loginAttempt };
          } else if (query['accountstate']) {
            return { success: false, reason: query['accountstate'], countryCode: countryCode };
          }
          if (query['accountsharing']) {
            return { success: true, url: res.url, accountSharing: true };
          }
          return { success: true, url: res.url };
        }
        return { success: false, reason: LoginErrorReason.UNKNOWN, countryCode: countryCode };
      }));
  }

  resetPasswordWithEmail(email: String): Observable<ResetPasswordDto> {
    return this.http.post('/login/pwreset', { email }).pipe(map((res: ResetPasswordDto) => res));
  }

  setupPassword(password: string, passwordCheck: string) {
    return this.http.post('/login/pwsetup', { password, passwordCheck }).pipe(map((res: ResetPasswordDto) => res));
  }
}



// WEBPACK FOOTER //
// ./ts/app/login/login.service.ts